import { Routes } from '@angular/router';
import { BlankTemplate } from './layout/blank-template/blank-template';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
 
  {
    path: '',
    loadComponent: () =>
      import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
      },
      {
        path: 'safety-program',
        loadComponent: () => import('./pages/placeholder/placeholder').then((m) => m.PlaceholderPage),
        data: { title: 'Safety Program' },
      },
      {
        path: 'faq',
        loadComponent: () => import('./pages/faq/faq').then((m) => m.Faq),
      },
      {
        path: 'help',
        loadComponent: () => import('./pages/help/help').then((m) => m.Help),
      },
      {
        path: 'contact-us',
        loadComponent: () => import('./pages/contact-us/contact-us').then((m) => m.ContactUs),
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      }
    ],
  },
  {
    path: 'auth',
    component: BlankTemplate,
    loadChildren: () => import('./pages/auth/auth-module').then((m) => m.AuthModule),
  },
  {
    path: 'user',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () => import('./pages/user/user-module').then((m) => m.UserModule),
  },
  {
    path: 'employment',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/employment/employment-module').then((m) => m.EmploymentModule),
  },
  {
    path: 'application',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/application/application-module').then((m) => m.ApplicationModule),
  },
  {
    path: 'document',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/documents/documents-module').then((m) => m.DocumentsModule),
  },
  {
    path: 'document-view',
    component: BlankTemplate,
    loadChildren: () =>
      import('./pages/documents/driver-documents/driver-document-view-module').then(
        (m) => m.DriverDocumentViewModule,
      ),
  },
  {
    path: 'scan',
    component:  BlankTemplate,
    loadChildren: () =>
      import('./pages/scan/scan-module').then((m) => m.ScanModule),
  },
  {
    path: 'carrier',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/carrier/carrier-module').then((m) => m.CarrierModule),
  },
  {
    path: 'credentials-fh',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/credentials-for-fh/credentials-for-fh-module').then((m) => m.CredentialsForFhModule),
  },
  {
    path: 'equipment',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/equipment/equipment-module').then((m) => m.EquipmentModule),
  },
  {
    path: 'credentials-equipment',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
      loadChildren: () =>
        import('./pages/credentials-for-equipment/credentials-for-equipment-module').then((m) => m.CredentialsForEquipmentModule),
  },
  {
    path: 'documents-equipment',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/documents-for-equipment/documents-for-equipment-module').then(
        (m) => m.DocumentsForEquipmentModule,
      ),
  },
  {
    path: 'permits-equipment',
    loadComponent: () => import('./layout/master-template/master-template').then((m) => m.MasterTemplate),
    loadChildren: () =>
      import('./pages/permits-for-equipment/permits-for-equipment-module').then(
        (m) => m.PermitsForEquipmentModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
